import { Injectable, Inject } from '@angular/core';
import { DateFormatterService } from '../../providers/date.formatter/date.formatter.service';
export enum REPORT_URL {
  collector = '/restconf/operations/ietf-lmap-report:report'
}

@Injectable()
export class TestServerConfigService {
  hostName: string;
  //eslint-disable-next-line
  constructor(
    private readonly dateFormatterService: DateFormatterService,
    //eslint-disable-next-line
    @Inject('environments') environments: any
  ) {
    this.hostName = environments?.EnvKeys?.CallHomeUrl;
  }

  getTestName(): string {
    const currentTimestamp = new Date().getTime();
    const date = this.dateFormatterService.getTime(currentTimestamp, 'YYYY-MM-DD:HH:mm:ss');
    return 'Test-' + date;
  }

  generateUUID(): string {
    // TODO: rely on a lib like this one: https://www.npmjs.com/package/uuid
    // to generate UUIDs.
    // for now use random.
    return Math.random().toString(36).substr(2);
  }

  //eslint-disable-next-line
  getCollectorConfig(): any {
    return {
      'fusion-collector': {
        protocol: this.getProtocol(),
        hostname: this.getHostname(),
        port: this.getPort(),
        timeout: 10000,
        reportUrl: REPORT_URL.collector
      }
    };
  }

  //eslint-disable-next-line
  getControllerConfig(): any {}

  getProtocol(): string {
    return 'http';
  }

  getHostname(): string {
    return this.hostName || window.location.hostname;
  }

  getPort(): string {
    return '8080';
  }
}
